/* Smelu — hCaptcha Badge Hider
 * hCaptcha-Badge wird nach jeder DOM-Mutation neu eingefügt.
 * MutationObserver fängt das ab und versteckt das Badge persistent.
 * Challenge-Modal (für Form-Submit) bleibt funktional — wir hiden nur
 * fixed-positioned Badges in der unteren rechten Ecke.
 */
(function () {
  'use strict';

  var HIDE_STYLE = 'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;position:fixed!important;bottom:-9999px!important;right:-9999px!important;width:1px!important;height:1px!important;overflow:hidden!important;';

  var SELECTORS = [
    '#shop-hcaptcha-badge-container',
    '.grecaptcha-badge',
    '[data-hcaptcha-widget-id]',
    '#protected-by-hcaptcha',
    '[id^="hcaptcha-protection"]',
    '.hcaptcha-badge',
    '.h-captcha-badge',
    'div[id^="hcaptcha-"]'
  ];

  function isLikelyBadgeIframe(el) {
    if (el.tagName !== 'IFRAME') return false;
    var src = el.getAttribute('src') || '';
    if (src.indexOf('hcaptcha.com') === -1 && src.indexOf('recaptcha') === -1) return false;
    var title = (el.getAttribute('title') || '').toLowerCase();
    // Challenge-Modals haben oft "challenge" im title — die NICHT verstecken
    if (title.indexOf('challenge') !== -1) return false;
    // Badge-Iframes haben oft "captcha" oder "protected" im title, oder kein title
    var style = el.getAttribute('style') || '';
    if (style.indexOf('position: fixed') !== -1 || style.indexOf('position:fixed') !== -1) {
      // Fixed-positioned iframe von hcaptcha → wahrscheinlich Badge
      return true;
    }
    return false;
  }

  function hideAll() {
    SELECTORS.forEach(function (sel) {
      try {
        var nodes = document.querySelectorAll(sel);
        nodes.forEach(function (el) {
          if (el.dataset.smeluHidden === '1') return;
          el.setAttribute('style', HIDE_STYLE);
          el.dataset.smeluHidden = '1';
        });
      } catch (e) { /* ignore */ }
    });

    // Iframe-Heuristik
    try {
      document.querySelectorAll('iframe').forEach(function (el) {
        if (el.dataset.smeluHidden === '1') return;
        if (isLikelyBadgeIframe(el)) {
          el.setAttribute('style', HIDE_STYLE);
          el.dataset.smeluHidden = '1';
        }
      });
    } catch (e) { /* ignore */ }
  }

  function init() {
    hideAll();
    // hCaptcha lädt async — re-run a few times
    [500, 1500, 3000, 6000].forEach(function (delay) {
      setTimeout(hideAll, delay);
    });

    // Beobachte DOM für dynamisch eingefügte Badges
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () { hideAll(); });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
